import { type ITimeTableProps } from '@interface/ICommon';
import classNames from 'classnames';
import { useEffect, useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import EventCard from './EventCard';

const Timetable: FC<ITimeTableProps> = ({ eventList, searchTime, isFetching, activeDate }) => {
    const [isToday, setIsToday] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (searchTime && activeDate) {
            const sDay = new Date(searchTime + 'Z');
            const cDate = `${sDay.getFullYear()}-${String(sDay.getMonth() + 1).padStart(2, '0')}-${String(sDay.getDate()).padStart(
                2,
                '0'
            )}`;

            setIsToday(cDate === activeDate);
        }
    }, [activeDate, searchTime]);

    return (
        <div className="wrap-timetable">
            {eventList &&
                Array.from({ length: 24 }, (_, idx) => {
                    const eventsAtHour = eventList.filter((event) => new Date(event.triggerTime + 'Z').getHours() === idx);
                    const idxTime = idx.toString().padStart(2, '0');
                    const hours = new Date(searchTime + 'Z').getHours().toString().padStart(2, '0');

                    return (
                        <div
                            key={idx}
                            className={classNames({
                                "active-time before:hidden before:content-[''] lg:before:inline-block before:w-[3px] before:h-[100%] before:bg-point before:absolute before:top-0 before:left-0":
                                    isToday && hours === idxTime,
                            })}
                        >
                            <div className="pt-[29px] p-[16px] border-b-[1px] border-gray008 lg:flex lg:pt-[12px] lg:pb-[6px] lg:px-[22px]">
                                <span className="time block text-lg16 text-black068 leading-[16px] mb-[10px] lg:w-[99px] lg:mt-[13px] lg:mb-0">
                                    {idxTime}:00
                                </span>
                                {eventsAtHour.length > 0 ? (
                                    <div className="wrap-eventcard w-[100%] lg:flex lg:flex-wrap lg:justify-between lg:w-[calc(100%-99px)]">
                                        {eventsAtHour.map((event, index) => (
                                            <EventCard key={index + '_' + event.triggerTime} event={event} />
                                        ))}
                                    </div>
                                ) : (
                                    <div className="mb-[47px] lg:mt-[13px] lg:mb-[68px] lg:flex lg:flex-wrap lg:justify-between w-[100%] lg:w-[calc(100%-99px)]">
                                        <p className="font-style-lg15-b030 leading-[15px]">{t('I018')}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};
export default Timetable;
